/**
 * Define icons that will be used for main sidebar section titles
 * @note If section does not have an icon defined here, only the section title will be rendered (without the icon).
 * @type {Object<string, {symbol: string, symbolPrefix: string}>}
 */
export const MAIN_SIDEBAR_SECTION_ICONS = {
	searchesSection: {symbol: 'ui-search', symbolPrefix: 'icofont-'},
	statisticsSection: {symbol: 'chart-line', symbolPrefix: 'icofont-'},
};